import { Box, Field, Input, InputGroup } from "@chakra-ui/react";
import React from "react";
import { useStyles } from "../../hooks/useStyles";
import useThemeColors from "../../hooks/useThemeColors";

interface Props {
  invalid?: boolean;
  required?: boolean;
  label?: string;
  type?: "text" | "email" | "date" | "tel" | "address";
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: () => void;
  error?: string;
  startElement?: React.ReactNode;
  endElement?: React.ReactNode;
  maxLength?: number;
  placeholder?: string;
  minW?: string | {};
  maxW?: string | {};
  useLabelStyle?: boolean;
  w?: string | {};
}

function TextInput({
  invalid,
  required,
  label,
  type = "text",
  name,
  value,
  onChange,
  onBlur,
  error,
  startElement,
  endElement,
  maxLength,
  placeholder = "",
  minW,
  maxW,
  w,
  useLabelStyle = false,
}: Props) {
  const { floatingLabelStyles } = useStyles();
  const colors = useThemeColors();
  if (startElement || endElement) {
    return (
      <Field.Root
        invalid={invalid}
        required={required}
        minW={minW}
        maxW={maxW}
        w={w}
      >
        {label && (
          <Field.Label>
            {label}
            <Field.RequiredIndicator />
          </Field.Label>
        )}
        <InputGroup
          startAddon={startElement}
          endAddon={endElement}
          startAddonProps={{ borderColor: colors.border.input }}
          endAddonProps={{ borderColor: colors.border.input }}
        >
          <Input
            borderColor={colors.border.input}
            type={type}
            name={name}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            maxLength={maxLength}
            placeholder={placeholder}
            fontSize="16px"
          />
        </InputGroup>
        <Field.ErrorText>{error}</Field.ErrorText>
      </Field.Root>
    );
  }

  return (
    <Field.Root invalid={invalid} required={required} w={w}>
      {label && (
        <Field.Label
          css={!placeholder && useLabelStyle ? floatingLabelStyles : {}}
        >
          {label}
          <Field.RequiredIndicator />
        </Field.Label>
      )}
      <Box pos="relative" w="full">
        <Input
          borderColor={colors.border.input}
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          placeholder={placeholder}
          className="peer"
          fontSize="16px"
          css={{
            "::selection": {
              backgroundColor: "red",
              color: "white",
            },
          }}
        />
        <Field.ErrorText>{error}</Field.ErrorText>
      </Box>
    </Field.Root>
  );
}

export default TextInput;
